module.exports = "<div class=\"pagination\">\n    <div class=\"prev\" *ngIf=\"showPrevPage\" (click)=\"prevPage()\">prev</div>\n    <div class=\"next\" *ngIf=\"showNextPage\" (click)=\"nextPage()\">next</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home3/usalinks/public_html/ally-book-source/src/app/blog/pagination/pagination.component.html
// module id = ../../../../../src/app/blog/pagination/pagination.component.html
// module chunks = main